var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBackgroundRightSectionOneMob(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 196,
    height: 468,
    viewBox: "0 0 196 468",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_2_150)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-36.621 131.168C3.28466 88.107 62.0705 54.0227 64.8902 110.32C68.4561 181.518 -5.30713 283.287 -45.2128 326.348C-85.1184 369.409 -48.1536 273.309 -46.8493 235.212C-45.5449 197.115 -76.5266 174.228 -36.621 131.168Z",
    fill: "#4D20FF"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_2_150)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 74.533,
    cy: 105.376,
    rx: 74.533,
    ry: 105.376,
    transform: "matrix(-0.0388744 -0.999244 0.654532 -0.756034 -127.155 404.261)",
    fill: "#FFD90F"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_2_150)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-48.2139 157.906C-22.1381 129.768 16.1269 111.817 17.6703 157.339C19.6221 214.91 -28.6893 284.674 -54.7651 312.812C-80.8409 340.949 -56.4034 269.879 -55.3662 239.584C-54.3289 209.288 -74.2897 186.043 -48.2139 157.906Z",
    fill: "#20E4FF"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_2_150",
    x: -193.689,
    y: -49.1775,
    width: 388.704,
    height: 516.405,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 65,
    result: "effect1_foregroundBlur_2_150"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_2_150",
    x: -230.115,
    y: 41.0583,
    width: 338.068,
    height: 418.117,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 50,
    result: "effect1_foregroundBlur_2_150"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_2_150",
    x: -166.752,
    y: 29.5762,
    width: 284.479,
    height: 389.696,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 50,
    result: "effect1_foregroundBlur_2_150"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundRightSectionOneMob);
export default __webpack_public_path__ + "static/media/backgroundRightSectionOneMob.889749ff60d2716df3eb30d1ecec02e9.svg";
export { ForwardRef as ReactComponent };